export const historyAction = {
  undo: 'undo',
  redo: 'redo',
} as const;

export type HistoryAction = keyof typeof historyAction;
